// Waste categories with color coding and specific types
export const WASTE_CATEGORIES = {
  fly_tipping: {
    name: 'Fly-Tipping',
    color: '#b45309',
    icon: '🚯',
    types: [
      'Household waste',
      'Construction rubble',
      'Garden waste',
      'Commercial waste',
      'Hazardous materials',
      'Furniture',
      'Appliances',
      'Others'
    ]
  },
  scrap_metal: {
    name: 'Scrap Metal',
    color: '#64748b',
    icon: '🔩',
    types: [
      'Ferrous metal (iron/steel)',
      'Non-ferrous metal (aluminium/copper)',
      'Vehicle parts',
      'Appliances',
      'Pipes and fittings',
      'Wire and cables',
      'Others'
    ]
  },
  miscellaneous: {
    name: 'Miscellaneous Waste',
    color: '#95a5a6',
    icon: '🗑️',
    types: [
      'General Waste',
      'Others'
    ]
  },
  domestic: {
    name: 'Domestic Waste',
    color: '#e67e22',
    icon: '🏠',
    types: [
      'Litter (general)',
      'Books',
      'Clothes',
      'Household waste',
      'Furniture',
      'Over-spilled bins',
      'Others'
    ]
  },
  biodegradable: {
    name: 'Biodegradable and Green Waste',
    color: '#2ecc71',
    icon: '🌿',
    types: [
      'Human excreta (feces)',
      'Animal excreta/faces',
      'Fresh food',
      'Cooked food',
      'Leaves and shrubs',
      'Agricultural/Farm waste',
      'Overgrown weeds',
      'Compost',
      'Manure',
      'Animal feed',
      'Others'
    ]
  },
  hospital: {
    name: 'Hospital and Medical Waste',
    color: '#e74c3c',
    icon: '🏥',
    types: [
      'Protective clothing and Masks',
      'Syringes and Needles',
      'Nappies and Incontinence',
      'Drugs and Medicines',
      'Medical Devices and Equipment',
      'Anatomical (human) waste',
      'Bagged clinical waste',
      'Laboratory waste',
      'Chemicals',
      'Others'
    ]
  },
  construction: {
    name: 'Construction and Buildings',
    color: '#f39c12',
    icon: '🏗️',
    types: [
      'Dirt and gravel',
      'Masonry and Concrete',
      'Insulation',
      'Wood and lumbar',
      'Glass',
      'Demolition waste',
      'Abandoned building',
      'Abandoned skip',
      'Asbestos',
      'Tiles and Ceramics',
      'Bathroom or Kitchen fixture',
      'Bituminous waste',
      'Asphalt',
      'Cables and Electric Wiring',
      'PVCs and Other Plastics',
      'Gypsum',
      'Metallic pipes and rods',
      'Doors and Windows',
      'Cement',
      'Paint',
      'Others'
    ]
  },
  commercial: {
    name: 'Commercial and Industrial Waste',
    color: '#34495e',
    icon: '🏢',
    types: [
      'Office furniture',
      'Carpets',
      'Paper or Cardboard',
      'Plastics',
      'Packaging waste',
      'Oil and solvents',
      'Chemicals',
      'Waste water',
      'Smoke and gas',
      'Others'
    ]
  },
  automobile: {
    name: 'Automobile Products',
    color: '#9b59b6',
    icon: '🚗',
    types: [
      'Vehicle parts (metal)',
      'Tyres',
      'Car seating',
      'Vehicle engine parts',
      'Car batteries',
      'Windshield',
      'Car Accessories',
      'Others'
    ]
  },
  electronic: {
    name: 'Electronic Waste',
    color: '#3498db',
    icon: '💻',
    types: [
      'TVs and Flat Screens',
      'Fridge and Freezers',
      'A/Cs',
      'Kitchen Appliances (white goods)',
      'Telecommunications equipment',
      'Computers',
      'Printers',
      'Electric tools',
      'Leisure equipment',
      'Sports and fitness equipment',
      'Lighting and light bulbs',
      'Batteries and power storage',
      'Others'
    ]
  },
  environmental: {
    name: 'Environmental and Municipal',
    color: '#16a085',
    icon: '🌍',
    types: [
      'Water leakage',
      'Sewage leak or sludge',
      'Energy/Power waste',
      'Greenhouse gas emissions',
      'Radioactive waste',
      'Other'
    ]
  },
  food_donation: {
    name: 'Food Donation',
    color: '#22c55e',
    icon: '🍲',
    types: [
      'Fresh Produce',
      'Cooked Meals',
      'Bakery Items',
      'Canned/Packaged Food',
      'Dairy Products',
      'Beverages',
      'Others'
    ]
  },
  charity_items: {
    name: 'Charity Items',
    color: '#8b5cf6',
    icon: '🎁',
    types: [
      'Clothes',
      'Electronics',
      'Bikes',
      'Books',
      'Toys',
      'Furniture',
      'Homeware',
      'Others'
    ]
  },
  missed_bin_collection: {
    name: 'Missed Bin Collection',
    color: '#dc3545',
    icon: '🗑',
    types: [
      'General Waste Bin',
      'Recycling Bin',
      'Garden / Green Waste Bin',
      'Food Waste Bin',
      'Bulky Waste Collection',
      'Others'
    ]
  }
};

// Get category by key
export const getCategoryByKey = (key) => {
  return WASTE_CATEGORIES[key] || null;
};

// Get all category keys
export const getCategoryKeys = () => {
  return Object.keys(WASTE_CATEGORIES);
};

// Get color by category key
export const getCategoryColor = (key) => {
  return WASTE_CATEGORIES[key]?.color || '#95a5a6';
};

// Get icon by category key
export const getCategoryIcon = (key) => {
  return WASTE_CATEGORIES[key]?.icon || '🗑️';
};

// Get name by category key
export const getCategoryName = (key) => {
  return WASTE_CATEGORIES[key]?.name || 'Unknown';
};
